module.exports = __webpack_public_path__ + "static/img/foot.da3f45e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/foot.png
// module id = SJeM
// module chunks = 19